export const data = [
  "Blazingly fast Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "Easy Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "Support when you need it Lorem ipsum dolor sit amet, consectetur adipiscing elit."
];
